import React, { useEffect, useState } from "react";
import { graphql } from "gatsby";
import { ScientistOfTheDayIndex } from "./ScientistOfTheDayIndex";
import { KontentComponentSettings } from "../../../types";
import { getMultiChoice } from "../../../lib/multichoice";
import { useScientistLinks } from "../../../lib/useScientistLinks";

interface Props extends KontentComponentSettings {}

const ScientistOfTheDayIndexContainer: React.FC<Props> = ({
  id,
  component_settings__anchor_name,
  component_settings__hide_on_mobile,
}) => {
  const SCIENTIST_LINKS_PAGINATED_COLLECTION_ROUTE = "/paginated-collections/";
  const scientistLinks = useScientistLinks();
  const pages = scientistLinks.pages;
  const firstPage = scientistLinks.firstPage;

  const labels = scientistLinks.labels;

  const [visibleLinks, setVisibleLinks] = useState(firstPage.links);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const fetchScientists = async () => {
      const page = pages[currentPage];

      if (!page) return;

      await fetch(
        SCIENTIST_LINKS_PAGINATED_COLLECTION_ROUTE + page.id + ".json"
      )
        .then((response) => response.json())
        .then((data) => setVisibleLinks(data.nodes[0].links));
    };

    fetchScientists();
  }, [currentPage]);

  return (
    <ScientistOfTheDayIndex
      scientistLinks={visibleLinks}
      labels={labels}
      currentLabel={currentPage}
      handleLabelClick={setCurrentPage}
      id={id}
      anchor={component_settings__anchor_name?.value}
      hideOnMobile={
        getMultiChoice(component_settings__hide_on_mobile) === "yes"
      }
    />
  );
};

export default ScientistOfTheDayIndexContainer;

export const fragmentScientistOfTheDayIndex = graphql`
  fragment ScientistOfTheDayIndex on kontent_item_component___scientist_of_the_day_listing {
    elements {
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
    }
  }
`;
